import {
	axios
} from '../utils'

export default Vue => {
	// mount the axios to Vue
	Object.defineProperties(Vue, {
		axios: {
			get: () => axios
		},
	})

	Object.defineProperties(Vue.prototype, {
		$axios: {
			get: () => axios
		},
	})
}



// WEBPACK FOOTER //
// ./src/libraries/plugins/axios.js